import axios from 'axios'
import authHeader from './auth-header'

class MatriculasV2Service {
  handoff (options = {}) {
    return axios.post(
      process.env.VUE_APP_API_URL + 'matriculas-v2/sso/ticket',
      {
        redirect_to: options.redirectTo || '/matriculas/pesquisa',
        embedded: !!options.embedded
      },
      { headers: authHeader() }
    )
  }

  async redirectUrl (options = {}) {
    const response = await this.handoff(options)
    return response.data.redirect_url
  }
}

export default new MatriculasV2Service()
